export enum SearchContextsEnum {
    text = 'text',
    header = 'header',
    lead = 'lead',
    body = 'body',
    images = 'images'
}
